import { getCustomers } from '@/services/customers';
import { useQuery } from '@tanstack/react-query';

export const useCustomers = (query: string, offset: number, pageSize: number) =>
  useQuery({
    queryKey: ['customers', query],
    queryFn: getCustomers({ query, pageSize: '10' }),
  });
